import React, { useState, useEffect } from 'react';
import '../styles/TextCaseConverter.css';

const TextCaseConverter: React.FC = () => {
  const [text, setText] = useState('');

  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (error) {
      console.error('AdSense error:', error);
    }
  }, []);

  const toUpper = () => setText(text.toUpperCase());
  const toLower = () => setText(text.toLowerCase());
  const toTitle = () =>
    setText(
      text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    );

  return (
    <div className="text-case-converter">
      <h2>Conversor de Caixa de Texto</h2>
      <p className="description">Digite seu texto e escolha como deseja transformá-lo.</p>
      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        rows={8}
        className="w-full p-2 border"
        placeholder="Digite ou cole seu texto aqui..."
      />
      <div className="buttons">
        <button onClick={toUpper}>MAIÚSCULAS</button>
        <button onClick={toLower}>minúsculas</button>
        <button onClick={toTitle}>Título</button>
      </div>
      {/* Google AdSense */}
      <div className="ad-container">
        <ins
          className="adsbygoogle"
          style={{ display: 'block' }}
          data-ad-client="ca-pub-1989683361613000"
          data-ad-slot="1234567890"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </div>
  );
};

export default TextCaseConverter;
